<template>
  <!-- Slider main container -->
  <div class="swiper vue-swiper" :class="'s-' + itemId">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slides -->
      <div v-for="image in images" class="swiper-slide">
          <div class="thumb-image img-content" :class="{'swiper-zoom-container': isZoom}">
            <img :data-src="image" class="img-responsive swiper-lazy">
            <div class="swiper-lazy-preloader"></div>
          </div>
      </div>
    </div>
    <!-- If we need pagination -->
    <div class="swiper-pagination"></div>

    <!-- If we need navigation buttons -->
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>

    <!-- If we need scrollbar -->
<!--    <div class="swiper-scrollbar"></div>-->
  </div>
</template>

<script>
import Swiper, {Zoom,Navigation,Pagination,Lazy} from 'swiper';
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/lazy";
import eventBus from "./EventBus.vue";

export default {
  name: "VueSwiper",
  data: function() {
    return {
      swiperItems: {}
    };
  },
  props: {
    images: Array,
    itemId: 0,
    isZoom: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    showModal: function(itemId) {
      eventBus.$emit('sendModal', {id: itemId});
    }
  },
  mounted: function () {
    let vm = this;
    this.swiperItems = new Swiper ('.vue-swiper.s-'+this.itemId, {
      modules: [Pagination, Navigation, Zoom, Lazy],
      zoom: vm.isZoom,
      loop: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      on: {
        imagesReady: function (swiper) {
          swiper.el.addEventListener('mouseout', function (e) {
            setTimeout(function tick() {
              swiper.zoom.out(e);
            }, 100);
          })
        },
        click: function (swiper, event) {
          if (vm.isZoom)
            swiper.zoom.toggle(event);
          else
            vm.showModal(vm.itemId);
        }
      }
    });
  },
}
</script>

<style scoped>

</style>